export const SET_TAB_INDEX = "SET_TAB_INDEX";
export const SET_TRANSPORT_ORDERS_FETCH_ACTIVATED = 'SET_TRANSPORT_ORDERS_FETCH_ACTIVATED';
export const SET_ACTIVE_TRANSPORT_ORDERS = 'SET_ACTIVE_TRANSPORT_ORDERS';
export const SET_COMPLETED_TRANSPORT_ORDERS = 'SET_COMPLETED_TRANSPORT_ORDERS';
export const SET_ACTIVE_TRANSPORT_ORDERS_EXPANDED_ROW_IDS = 'SET_ACTIVE_TRANSPORT_ORDERS_EXPANDED_ROW_IDS';